/**
 * What share of the whole each value is, in %, in the order given; undefined
 * for a value that is no part of the whole.
 *
 * Values of one sign are the parts of their total. With both signs present the
 * whole is what the positive values add up to, and a negative value is an
 * offset against it. Counted as a part, it would shrink the total every share
 * is measured against: the shares would no longer add up to 100, and would
 * grow without bound as the values came close to cancelling out.
 */
export function sharesOf(values: readonly number[]): (number | undefined)[] {
  const gains = values.filter((v) => v > 0);
  const mixed = gains.length > 0 && values.some((v) => v < 0);
  const whole = (mixed ? gains : values).reduce((sum, v) => sum + v, 0);
  return values.map((v) => {
    if (mixed && v < 0) return undefined;
    // only a list of nothing but zeros adds up to none
    return whole === 0 ? 0 : (v / whole) * 100;
  });
}
